var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getHeaders } from "../utils/apiUtils";
import { API_PATHS, legalDepositsPeriodicalCheckTasksIdClose, legalDepositsPeriodicalCheckTasksIdCommunications, legalDepositsPeriodicalCheckTasksIdInquiry, legalDepositsPeriodicalCheckTasksIdInquiryPreview, legalDepositsPeriodicalCheckTasksIdPostpone, legalDepositsPeriodicalsIdCheckSettings, legalDepositsPeriodicalsIdContinuousNumbering, legalDepositsPeriodicalsIdContinuousNumberingPreview, legalDepositsPeriodicalsIdNextIssueNumber, } from "../types/apiPaths";
var handleResponse = function (response) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    });
}); };
export var fetchPeriodicalCheckTasks = function (kyInstance_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([kyInstance_1], args_1, true), void 0, function (kyInstance, params) {
        var searchParams_1, response, error_1;
        var _a, _b, _c;
        if (params === void 0) { params = {}; }
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 3, , 4]);
                    searchParams_1 = new URLSearchParams();
                    (_a = params.status) === null || _a === void 0 ? void 0 : _a.forEach(function (status) { return searchParams_1.append("status", status); });
                    if (params.libraryId) {
                        searchParams_1.append("libraryId", params.libraryId);
                    }
                    if (params.provisional)
                        searchParams_1.append("provisional", "true");
                    if (params.search)
                        searchParams_1.append("search", params.search);
                    if (params.sortBy)
                        searchParams_1.append("sortBy", params.sortBy);
                    if (params.sortDir)
                        searchParams_1.append("sortDir", params.sortDir);
                    if (params.exactCount)
                        searchParams_1.append("exactCount", "true");
                    searchParams_1.append("offset", String((_b = params.offset) !== null && _b !== void 0 ? _b : 0));
                    searchParams_1.append("limit", String((_c = params.limit) !== null && _c !== void 0 ? _c : 100));
                    return [4 /*yield*/, kyInstance.get("".concat(API_PATHS.LEGAL_DEPOSITS_PERIODICAL_CHECK_TASKS, "?").concat(searchParams_1.toString()), { headers: getHeaders() })];
                case 1:
                    response = _d.sent();
                    return [4 /*yield*/, handleResponse(response)];
                case 2: return [2 /*return*/, _d.sent()];
                case 3:
                    error_1 = _d.sent();
                    console.error("Error fetching periodical check tasks:", error_1);
                    throw error_1;
                case 4: return [2 /*return*/];
            }
        });
    });
};
export var fetchPeriodicalCheckTaskCount = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.get(API_PATHS.LEGAL_DEPOSITS_PERIODICAL_CHECK_TASKS_COUNT, { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, handleResponse(response)];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_2 = _a.sent();
                console.error("Error fetching periodical check task count:", error_2);
                throw error_2;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var fetchIssueInquiryPreview = function (kyInstance, taskId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.get(legalDepositsPeriodicalCheckTasksIdInquiryPreview(taskId), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, handleResponse(response)];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_3 = _a.sent();
                console.error("Error fetching issue inquiry preview:", error_3);
                throw error_3;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var sendIssueInquiry = function (kyInstance, taskId, request) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.post(legalDepositsPeriodicalCheckTasksIdInquiry(taskId), { headers: getHeaders(), json: request })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, handleResponse(response)];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_4 = _a.sent();
                console.error("Error sending issue inquiry:", error_4);
                throw error_4;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var postponeCheckTask = function (kyInstance, taskId, request) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.patch(legalDepositsPeriodicalCheckTasksIdPostpone(taskId), { headers: getHeaders(), json: request })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, handleResponse(response)];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_5 = _a.sent();
                console.error("Error postponing periodical check task:", error_5);
                throw error_5;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var closeCheckTask = function (kyInstance, taskId, request) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.patch(legalDepositsPeriodicalCheckTasksIdClose(taskId), { headers: getHeaders(), json: request })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, handleResponse(response)];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_6 = _a.sent();
                console.error("Error closing periodical check task:", error_6);
                throw error_6;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var fetchCheckTaskCommunications = function (kyInstance, taskId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.get(legalDepositsPeriodicalCheckTasksIdCommunications(taskId), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, handleResponse(response)];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_7 = _a.sent();
                console.error("Error fetching check task communications:", error_7);
                throw error_7;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var updatePeriodicalCheckSettings = function (kyInstance, titleId, request) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, kyInstance.patch(legalDepositsPeriodicalsIdCheckSettings(titleId), { headers: getHeaders(), json: request })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.statusText));
                }
                return [3 /*break*/, 3];
            case 2:
                error_8 = _a.sent();
                console.error("Error updating periodical check settings:", error_8);
                throw error_8;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var previewContinuousNumbering = function (kyInstance, titleId, request) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kyInstance
                .post(legalDepositsPeriodicalsIdContinuousNumberingPreview(titleId), {
                json: request,
                headers: getHeaders(),
            })
                .json()];
    });
}); };
export var applyContinuousNumbering = function (kyInstance, titleId, request) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.put(legalDepositsPeriodicalsIdContinuousNumbering(titleId), {
                    json: request,
                    headers: getHeaders(),
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
export var fetchNextIssueNumber = function (kyInstance, titleId, volumeId) { return __awaiter(void 0, void 0, void 0, function () {
    var query, response, error_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                query = volumeId ? "?volumeId=".concat(encodeURIComponent(volumeId)) : "";
                return [4 /*yield*/, kyInstance.get("".concat(legalDepositsPeriodicalsIdNextIssueNumber(titleId)).concat(query), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, handleResponse(response)];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_9 = _a.sent();
                console.error("Error fetching next issue number:", error_9);
                throw error_9;
            case 4: return [2 /*return*/];
        }
    });
}); };
